import React from 'react';

import Link from 'next/link';

import { withEventScope } from '@repo/event-processor';
import { Badge } from '@repo/ui-kit/components/core/Badge';
import { H4, H5, P2, P3 } from '@repo/ui-kit/components/core/Typography';

import { CardImage, CardWrapper, CardBody, ImageWrapper } from './styles';
import { HighlightInfoProps } from './types';

/**
 * A highlight info section on the navigation
 */
const HighlightInfo: React.FC<HighlightInfoProps> = ({
  title,
  description,
  badgeText,
  isMobile,
  image,
  mainUrl,
  onClick,
}) => {
  const Header = isMobile ? H5 : H4;
  const Description = isMobile ? P3 : P2;
  return (
    <Link href={mainUrl} style={{ height: '100%' }} onClick={onClick}>
      <CardWrapper>
        <ImageWrapper isMobile={isMobile}>
          <CardImage fill alt={image.alt} src={image.url} />
        </ImageWrapper>
        <CardBody>
          {badgeText && <Badge size="s" text={badgeText} variant="soft-info" />}
          <Header bold as="span">
            {title}
          </Header>
          <Description>{description}</Description>
        </CardBody>
      </CardWrapper>
    </Link>
  );
};
export default withEventScope(HighlightInfo, { module: 'highlightInfo' });
